import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./styles.css";

const container = document.getElementById("root");
const app = (
  <React.StrictMode>
    <App initialPath={window.location.pathname} />
  </React.StrictMode>
);
const hydrateOrRender = () => {
  if (container.hasChildNodes()) {
    ReactDOM.hydrateRoot(container, app);
  } else {
    ReactDOM.createRoot(container).render(app);
  }
};

if (process.env.NODE_ENV === "test") {
  hydrateOrRender();
} else if (typeof window !== "undefined" && "requestIdleCallback" in window) {
  window.requestIdleCallback(hydrateOrRender, { timeout: 1500 });
} else {
  setTimeout(hydrateOrRender, 0);
}
